<template>
  <div>
    <div class="returnFunc">
      <!-- <el-button class="report" type="danger" icon="el-icon-collection" @click="toReport"
        >生成使用报告</el-button
      > -->
      <el-button class="goBack" @click="goBack" plain>返回</el-button>
    </div>
    <div class="detailContent">
      <div class="equiDetail">
        <div class="leftequi" @click="preDot(selectIndex - 1)">
          <div class="leftequiicon">
            <i class="el-icon-arrow-left" style="color: white"></i>
          </div>
        </div>
        <PaverTable v-if="isTanpuji" :EquipObj="EquipObj" />
        <RollerTable v-if="isYaluji" :EquipObj="EquipObj" />
        <MillerTable v-if="isXibaoji" :EquipObj="EquipObj" />
        <div class="leftequi" @click="nextDot(selectIndex + 1)">
          <div class="leftequiicon right">
            <i
              class="el-icon-arrow-right"
              style="color: white; font-weight: bold"
            ></i>
          </div>
        </div>
      </div>
      <div class="panelContent">
        <div class="panel1">
          <EquipPanel :config="config1" />
        </div>
        <div class="panel2">
          <EquipPanel :config="config2" />
        </div>
        <div v-if="isYaluji" class="panel3">
          <EquipPanel :config="config3" />
        </div>
        <div v-if="isTanpuji" class="panel3_t">
          <EquipPanel :config="config31" />
        </div>
        <div v-if="isXibaoji" class="panel3_t">
          <EquipPanel :config="config32" />
        </div>
        <div class="panel4">
          <EquipPanel :config="config4" />
        </div>
      </div>
      <div class="detailPages">
        <div class="blockHeader">
          <div class="redBlock"></div>
          <div class="headerText">设备详情</div>
          <div class="workListTable" id="nav">
            <span
              class="workItem"
              v-for="(item, index) in equPages"
              :key="index"
              :class="{ activeWorkItem: index == workIndex }"
              @click="equClick(index)"
            >
              <span class="workItemText">{{ item }}</span>
            </span>
          </div>
          <!-- <el-button v-show="downloadExcelShow" class="download" type="warning" plain @click="downloadExcel" icon="el-icon-download">数据下载</el-button>
          <el-button v-show="!downloadExcelShow" class="download" type="warning" :loading="true" plain>下载..</el-button> -->
        </div>
        <div
          class="line"
          style="
            height: 1px;
            background-color: #e1e1e1;
            width: 98.5%;
            margin: 0 auto;
          "
        ></div>
        <div class="pageContent" :class="workIndex == 0?'pageContent1':''">
          
          <OilWear
            ref="oilwear"
            :workIndex="workIndex"
            :code="code"
            v-show="workIndex == 0"
          />
          <WorkTime
            ref="worktime"
            :workIndex="workIndex"
            :code="code"
            v-show="workIndex == 1"
          />
          <Mileage
            ref="mileage"
            :workIndex="workIndex"
            :code="code"
            v-show="workIndex == 2"
          />
          <WarnResume
            :workIndex="workIndex"
            :code="code"
            v-show="workIndex == 3"
            @jumper="jumperFun"
          />
          <TakeCare
            :workIndex="workIndex"
            :code="code"
            v-show="workIndex == 4"
          />
          <Inquiry
            ref="inquiry"
            :workIndex="workIndex"
            :code="code"
            v-show="workIndex == 5"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EquipPanel from "../../components/chart/panel2";
import RollerTable from "./part/rollertable";
import PaverTable from "./part/pavertable";
import MillerTable from "./part/millertable";
import WorkTime from "./part/worktime";
import Mileage from "./part/mileage";
import OilWear from "./part/oilwear";
import WarnResume from "./part/warnresume";
import TakeCare from "./part/takecare";
import Inquiry from "./part/inquiry";
import {
  getEquipDetails,
  getDigital,
  getEquipsCodeAndType,
  // exportExcelEquipOtherReport
} from "../../utils/api";
import { Message} from 'element-ui';
import { toChineseDate,getDay,getMinite } from "../../utils/commons";
export default {
  name: "app",
  data() {
    return {
      equPages: [
        "油耗",
        "开机时长",
        "行驶里程",
        "报警履历",
        "维保记录",
        "综合查询"
      ],
      typeName: "压路机",
      riskStatus: 0,
      healthStatus: 0,
      equipCode: "",
      code: "",
      mode: "",
      isTanpuji: false, //是否为摊铺机
      isYaluji: false, //是否为压路机
      isXibaoji: false, //是否为铣刨机
      EquipObj: {
      },
      timer: 0,
      // startTime:'',
      // endTime:'',
      equipList: [],//设备列表
      selectIndex: 0,//code在设备列表中的索引
      config1: {},
      config2: {},
      config3: {},
      config4: {},
      config31: {},
      canzhaoList:{
        "23": "摊铺机预留",
        "24": "摊铺机预留",
        "25": "摊铺机预留",
        "26": "摊铺机预留",
        "27": "摊铺机",
        "28": "无人摊铺机",
        "29": "单钢轮压路机",
        "30": "双钢轮压路机",
        "31": "胶轮压路机",
        "32": "无人单钢轮压路机",
        "33": "无人双钢轮压路机",
        "34": "无人胶轮压路机",
        "35": "铣刨机"
      },
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "设备详情",
          path: "/transfer/equipmentInfo",
        },
      ],
      workIndex: 0,
      // downloadExcelShow: true,
      corpCode:localStorage.getItem("corpCode"),
      inArrow: ''
    };
  },
  computed: {},
  components: {
    RollerTable,
    PaverTable,
    EquipPanel,
    WorkTime,
    Mileage,
    OilWear,
    WarnResume,
    TakeCare,
    Inquiry,
    MillerTable
  },
  created() {
    this.inArrow = this.$route.params.inArrow || JSON.parse(sessionStorage.getItem("inArrow"));
    let setOne = ''
    console.log(this.inArrow)
    if(this.inArrow == 'equipmentMonitor'){
      setOne = {
        name: "位置监控",
        path: "/transfer/equipmentMonitor",
      }
    }else if(this.inArrow == 'digitization'){
      setOne = {
        name: "设备数字化管理",
        path: "/transfer/digitization",
      }
    }else if(this.inArrow == 'equipmentList'){
      setOne = {
        name: "基础管理",
        path: "/transfer/equipmentList",
      }
    }
    if(this.inArrow != 'equipmentCenter'){
      this.arrowList.splice(1,0,setOne)
    }
    console.log(this.arrowList)
    this.$store.commit("setArrowList", this.arrowList);
    window.scrollTo(0,0);
    this.typeName = this.$route.params.typeName || JSON.parse(sessionStorage.getItem("typeName"));
    // console.log(this.$route.params.code)
    this.code = this.$route.params.code || JSON.parse(sessionStorage.getItem("code"));
    this.selectIndex = JSON.parse(sessionStorage.getItem("selectIndex")) || 0;
    //防止刷新丢失code和typeName
    sessionStorage.setItem("code", JSON.stringify(this.code));
    sessionStorage.setItem("typeName", JSON.stringify(this.typeName));
    sessionStorage.setItem("inArrow", JSON.stringify(this.inArrow));
    this.turnTOzero();//仪表数据归零
  },
  mounted() {
    let params = {
      code: this.code,
    };
    this.getEquipList();//获取设备列表和设备索引
    this.getEquipInfo(params); //获取表格详细信息
    this.getDigitalInfo(params); //获取仪表盘信息
    if(this.$route.params.index){
      this.equClick(this.$route.params.index)
    }
  },
  methods: {
    //报警页跳转到其它页
    jumperFun(obj,type){
      console.log(obj,type)
      let startTime=obj.startTime
      let endTime=obj.endTime
      startTime=startTime.replace('年','-')
      startTime=startTime.replace('月','-')
      startTime=startTime.replace('日','')
      endTime=endTime.replace('年','-')
      endTime=endTime.replace('月','-')
      endTime=endTime.replace('日','')
      if(endTime==''){
        endTime=startTime
      }
      if(type=='oil'){
        this.$refs.oilwear.value1=[startTime.substring(0,10),startTime.substring(0,10)]
        this.$refs.oilwear.period=0
        this.equClick(0)
      }else if(type=='oiltotal'){
        this.$refs.oilwear.value1=[getDay(-3,startTime.substring(0,10)),getDay(3,endTime.substring(0,10))]
        this.$refs.oilwear.period=0
        this.equClick(0)
      }else if(type=='worktime'){
        this.$refs.worktime.value1=[getDay(-3,startTime.substring(0,10)),getDay(3,endTime.substring(0,10))]
        this.$refs.worktime.period=0
        this.equClick(1)
      }else if(type=='mileage'){
        this.$refs.mileage.value1=[getDay(-3,startTime.substring(0,10)),getDay(3,endTime.substring(0,10))]
        this.$refs.mileage.period=0
        this.equClick(2)
      }else if(type=='inquiry'){
        this.$refs.inquiry.value1=[getMinite(-1,startTime),getMinite(1,endTime)]
        if(obj.warnCont=='水温异常'){
          this.$refs.inquiry.checkedCities=['engineTemperature']
          this.$refs.inquiry.handleCheckedCitiesChange(['engineTemperature'])
          this.$refs.inquiry.maintaiSearch='发动机水温(℃)'
          this.$refs.inquiry.pageMsg.pageNo=1
        }else if(obj.warnCont=='超速报警'){
          this.$refs.inquiry.checkedCities=['speed']
          this.$refs.inquiry.handleCheckedCitiesChange(['speed'])
          this.$refs.inquiry.maintaiSearch='速度(KM/H)'
          this.$refs.inquiry.pageMsg.pageNo=1
        }else if(obj.warnCont=='机油压力低'){
          this.$refs.inquiry.checkedCities=['oilPressureValue']
          this.$refs.inquiry.handleCheckedCitiesChange(['oilPressureValue'])
          this.$refs.inquiry.maintaiSearch='机油压力(MPa)'
          this.$refs.inquiry.pageMsg.pageNo=1
        }
        this.equClick(5)
        this.$refs.inquiry.doSearch()
      }else if(type=='playback'){
        if(obj.workId &&obj.projectId){
          this.$router.push({name:'MonitorRe',query:{workId:obj.workId,projectId:obj.projectId,type:'RE'},params:{
            date:startTime.substring(0,10),
            // date:'2021-06-08',
            // startTime:'08:10',
            // endTime:'08:12'
            startTime:getMinite(-1,startTime).substring(11,16),
            endTime:getMinite(1,endTime).substring(11,16)
          }})
        }else{
          Message.warning('暂无归属的工程或作业，无法查看报警分析')
        }
      }
    },
    turnTOzero(){
        this.config1= {
        title: "数字仪表",
        circleConfig: [
          {
            id: this.uuid(),
            title: "发动机水温",
            color: "#F6C021",
            percent: "无数据",
            name1: "当前水温",
            unit: "°C",
            content: 100,
            name2: "水温上限",
          },
          {
            id: this.uuid(),
            title: "速度",
            color: "#4facf9",
            content: 10,
            percent: "无数据",
            unit: "km/h",
          },
          {
            id: this.uuid(),
            title: "发动机转速",
            color: "#f6c018",
            content: 3000,
            percent: "无数据",
            unit: "r/min",
          },
          {
            id: this.uuid(),
            title: "机油压力",
            color: "#4facf9",
            content: "50",
            percent: "无数据",
            unit: "MPa",
            name1: "当前机油压力",
            name2: "机油压力上限",
          },
        ],
      };
      this.config2= {
        title: "实时消耗",
        circleConfig: [
          {
            id: this.uuid(),
            title: "剩余油量",
            color: "#e86b59",
            content: 100,
            percent: "无数据",
            unit: "%",
            name1: "当前油量",
            name2: "油量上限",
          },
        ],
      };
      this.config3= {
        title: "碾压反馈",
        circleConfig: [
          {
            id: this.uuid(),
            title: "碾压温度",
            color: "#f6c018",
            content: "100",
            percent: "无数据",
            unit: "°C",
          },
          {
            id: this.uuid(),
            title: "振动频率",
            color: "#4facf9",
            content: "10",
            percent: "无数据",
            unit: "Hz",
          },
          {
            id: this.uuid(),
            title: "振动幅度",
            color: "#f6c018",
            content: "600",
            percent: "无数据",
            unit: "mm",
          },
        ],
      };
      this.config4= {
        title: "今日作业",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日已作业时长",
            color: "#e86b59",
            content: "24",
            percent: "无数据",
            unit: "H",
            name1: "作业时长",
              name2: "最大时长",
          },
          {
            id: this.uuid(),
            title: "今日已作业里程",
            color: "#e86b59",
            content: "3000",
            percent: "无数据",
            unit: "m",
            name1: "当前里程",
            name2: "最大里程",
          },
        ],
      };
      this.config31= {
        title: "摊铺控制",
        circleConfig: [
          {
            id: this.uuid(),
                title: "摊铺温度",
                color: "#4FACFA",
                percent: "无数据",
                name1: "当前温度",
                unit: "°C",
                content: 200,
                name2: "最高温度",
          },
              {
                id: this.uuid(),
                title: "振捣频率",
                color: "#4FACFA",
                content: 120,
                percent: "无数据",
                unit: "Hz",
                name1: "当前频率",
                name2: "平均频率",
              },
        ],
      };
      this.config32= {
        title: "铣刨控制",
        circleConfig: [
          {
            id: this.uuid(),
                title: "铣刨深度",
                color: "#4FACFA",
                percent: "无数据",
                name1: "当前深度",
                unit: "mm",
                content: 1000,
                name2: "平均深度",
          }
        ],
      };
    },
    //切换详情页
    equClick(index) {
      this.workIndex = index;
    },
    preDot(index) {
      if (index < 0) {
        this.selectIndex = 0;
        Message.warning("已经是第一个了");
        return;
      }
      this.DotChange(index);
    },
    nextDot(index) {
      if (index >= this.equipList.length) {
        this.selectIndex = this.equipList.length - 1;
        Message.warning("已经是最后一个了");
        return;
      }
      this.DotChange(index);
    },
    DotChange(index) {
      this.turnTOzero();
      this.selectIndex = index;
      this.workIndex = 9;
      setTimeout(()=>{
        this.workIndex = 0;
      },1)
      this.code = this.equipList[index].code;
      this.typeName = this.equipList[index].typeName;
      let params = { code: this.code };
      this.getEquipInfo(params); //获取表格详细信息
      this.getDigitalInfo(params);
      sessionStorage.setItem("selectIndex", JSON.stringify(this.selectIndex));
      sessionStorage.setItem("code", JSON.stringify(this.code));
      sessionStorage.setItem("typeName", JSON.stringify(this.typeName));
    },
    goBack() {
      sessionStorage.removeItem("selectIndex");
      this.$router.go(-1);
    },
    getEquipList() {
      getEquipsCodeAndType({corpCode:this.corpCode}).then((res) => {
        this.equipList = res.data.content.map((item) => {
          return {
            code: item.code,
            typeName: this.canzhaoList[item.type+''],
          };
        });
        console.log(this.equipList ,'this.equipList ')
        this.selectIndex =
          this.equipList.findIndex((item) => {
            return item.code == this.code;})
          // }) || JSON.parse(sessionStorage.getItem("selectIndex"));
        sessionStorage.setItem("selectIndex", JSON.stringify(this.selectIndex));
      });
    },
    getEquipInfo(params) {
      //获取表格数据
      getEquipDetails(params).then((res) => {
        if(!res.data.content) return;
        this.EquipObj = res.data.content.info;
        if(this.EquipObj.latestOnline!=null){
          this.EquipObj.latestOnline=toChineseDate(this.EquipObj.latestOnline+"");
        }
        this.typeName = this.EquipObj.typeName;
      });
    },
    //定时器函数
    setIntervalFun(){
        this.time=null
        this.timer=setTimeout(()=>{
          this.getDigitalInfo({code:this.code});
          this.getEquipInfo({code:this.code});
          clearTimeout(this.timer);
          this.setIntervalFun();
      },10000)
    },
    //获取仪表盘数据
    getDigitalInfo(params) {
      getDigital(params).then((res) => {
        if(!res.data.content) return;
        let info = res.data.content.info;
        if (this.isYaluji) {
          this.config3 = {
            title: "碾压反馈",
            circleConfig: [
              {
                id: this.uuid(),
                title: "碾压温度",
                color: "#4FACFA",
                percent: info.temperature==null?"无数据":info.temperature.toFixed(1)*1,
                name1: "当前温度",
                unit: "°C",
                content: 100,
                name2: "温度上限",
              },
              {
                id: this.uuid(),
                title: "振动频率",
                color: "#E96B5A",
                content: 120,
                percent: info.frequencyVal==null?"无数据":info.frequencyVal.toFixed(1)*1,
                unit: "Hz",
                name1: "当前频率",
                name2: "频率上限",
              },
              {
                id: this.uuid(),
                title: "振动幅度",
                color: "#62DAAA",
                content: 130,
                percent: info.swingVal==null?"无数据":info.swingVal.toFixed(1)*1,
                unit: "mm",
                name1: "当前振幅",
                name2: "振幅上限",
              },
            ],
          };
        } else if(this.isTanpuji){
          this.config31 = {
            title: "摊铺控制",
            circleConfig: [
              {
                id: this.uuid(),
                title: "摊铺温度",
                color: "#4FACFA",
                percent: info.temperature7==null?"无数据":info.temperature7.toFixed(1)*1,
                name1: "当前温度",
                unit: "°C",
                content: 200,
                name2: "最高温度",
              },
              {
                id: this.uuid(),
                title: "振捣频率",
                color: "#4FACFA",
                content: 130,
                percent: info.freqency==null?"无数据":info.freqency.toFixed(1)*1,
                unit: "Hz",
                name1: "当前频率",
                name2: "平均频率",
              },
            ],
          };
        }else if(this.isXibaoji){
          this.config32= {
            title: "铣刨控制",
            circleConfig: [
              {
                id: this.uuid(),
                    title: "铣刨深度",
                    color: "#4FACFA",
                    percent:  info.depth==null?"无数据":info.depth.toFixed(1)*1,
                    name1: "当前深度",
                    unit: "mm",
                    content: 1000,
                    name2: "平均深度",
              }
            ],
          };
        }
        this.config2 = {
          title: "实时消耗",
          circleConfig: [
            {
              id: this.uuid(),
              title: "剩余油量",
              color: "#62DAAA",
              content: 100,
              percent: info.oilmass==null?"无数据":info.oilmass.toFixed(1)*1,
              unit: "%",
              name1: "当前油量",
              name2: "油量上限",
            },
          ],
        };
        this.config1 = {
          title: "数字仪表",
          circleConfig: [
            {
              id: this.uuid(),
              title: "发动机水温",
              color: "#F6C021",
              percent: info.engineTemperature==null?"无数据":info.engineTemperature.toFixed(1)*1,
              name1: "当前水温",
              unit: "°C",
              content: 100,
              name2: "水温上限",
            },
            {
              id: this.uuid(),
              title: "速度",
              color: "#4FACFA",
              content: 8,
              percent: info.speed==null?"无数据":info.speed.toFixed(1)*1,
              unit: "km/h",
              name1: "当前速度",
              name2: "速度上限",
            },
            {
              id: this.uuid(),
              title: "发动机转速",
              color: "#4FACFA",
              content: 1800,
              percent: info.engineSpeed==null?"无数据":info.engineSpeed.toFixed(0),
              unit: "r/min",
              name1: "当前发动机转速",
              name2: "发动机转速上限",
            },
            {
              id: this.uuid(),
              title: "机油压力",
              color: "#62DAAA",
              content: 50,
              percent: info.oilPressureValue==null?"无数据":info.oilPressureValue.toFixed(1)*1,
              unit: "MPa",
              name1: "当前机油压力",
              name2: "机油压力上限",
            },
          ],
        };
        this.config4 = {
          title: "今日作业",
          circleConfig: [
            {
              id: this.uuid(),
              title: "今日已作业时长",
              color: "#E96B5A",
              percent: info.workTimeToday==null?"无数据":info.workTimeToday.toFixed(1)*1,
              unit: "H",
              content: 24,
              name1: "作业时长",
              name2: "最大时长",
            },
            {
              id: this.uuid(),
              title: "今日已作业里程",
              color: "#62DAAA",
              content: 3000,
              percent: info.finishedMileageToday==null?"无数据":info.finishedMileageToday.toFixed(1)*1,
              unit: "m",
              name1: "当前里程",
              name2: "最大里程",
            },
          ],
        };
      });
    },
  },
  beforeDestroy(){
    clearTimeout(this.timer);
  },
  watch: {
    typeName(val) {
      if(val){
        if (val.includes("摊铺机")) {
          this.isXibaoji = false;
          this.isYaluji = false;
          this.isTanpuji = true;
        } else if(val.includes("压路机")) {
          this.isXibaoji = false;
          this.isYaluji = true;
          this.isTanpuji = false;
        }else if(val.includes("铣刨机")) {
          this.isXibaoji = true;
          this.isYaluji = false;
          this.isTanpuji = false;
        }
      }
    },
    code(val){
      this.getDigitalInfo({code:val});
      this.getEquipInfo({code:val});
      clearTimeout(this.timer);
      this.setIntervalFun();
    },

  },
};
</script>
<style lang="scss">
 .option_excel{
   height: 32px !important;
   margin-bottom: 5px;
   width: 220px !important;
   .el-input__inner{
    height: 32px !important;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
  }
 }
 .picker_excel{
    margin-bottom: 5px !important;
  }
 .button_excel{
   height: 28px !important;
   padding-top: 7px !important;
 }
 .itemLeft{
   .el-icon-location-outline{
     margin-left: 5px;
     color:#e96b5a;
     cursor: pointer;
     font-size: 16px;
   }
 }
</style>
<style lang="scss" scoped="">
.returnFunc {
  position: fixed;
  top: 68px;
  right: 15px;
  z-index: 1000;
}
.detailContent {
  width: 98.5%;
  height: auto;
  padding-bottom: 21px;
  margin: 0 auto;
  margin-bottom: 10px;
  .equiDetail {
    width: 100%;
    height: 242px;
    display: flex;
    .leftequi {
      width: 50px;
      height: 242px;
      background: #ffffff;
      border: 1px solid #e4e7ed;
      cursor: pointer;
      .leftequiicon {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: #cacad4;
        margin: 0 auto;
        transform: translateY(110px);
        i {
          line-height: 22px;
          text-indent: 2px;
        }
      }

      .right {
        i {
          text-indent: 3px;
        }
      }
    }
  }
  .leftequi:hover {
    background: #e3e3e9;
  }
  .panelContent {
    width: 100%;
    height: auto;
    margin-top: 12px;
    background: #ffffff;
    border: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    .panel1 {
      // width: 668px;
      height: 222px;
    }
    .panel2 {
      // width: 202px;
      height: 222px;
    }
    .panel2_t {
      // width: 202px;
      height: 222px;
    }
    .panel3 {
      // width: 504px;
      height: 222px;
    }
    .panel3_t {
      // width: 692px;
      height: 222px;
    }
    .panel4 {
      // width: 362px;
      height: 222px;
    }
  }
  .detailPages {
    width: 100%;
    height: 722px;
    background: #ffffff;
    margin-top: 10px;
    border: 1px solid #e4e7ed;
    .blockHeader {
      width: 100%;
      height: 60px;
      position: relative;
      .redBlock {
        height: 18px;
        width: 4px;
        position: absolute;
        background-color: #e96b5a;
        top: 19px;
        left: 24px;
      }
      .headerText {
        height: 16px;
        line-height: 16px;
        color: #222222;
        display: inline-block;
        position: absolute;
        top: 21px;
        left: 38px;
        font-weight: 600;
      }
      .workListTable {
        width: 1200px;
        height: 40px;
        position: absolute;
        top: 15px;
        left: 130px;
        // background-color: aquamarine;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        .workItem {
          &.activeWorkItem {
            background-color: #e96b5a;
            .workItemText {
              color: #ffffff;
            }
          }
          color: #e96b5a;
          background: #fdf0ef;
          border-color: #f6c4bd;
          height: 32px;
          width: auto;
          display: inline-block;
          line-height: 30px;
          font-size: 14px;

          margin-right: 10px;
          margin-left: 10px;
          // padding: 0 30px;
          vertical-align: top;
          // border: 1px solid #e96b5a;
          box-sizing: border-box;
          transform: skewX(-20deg);
          cursor: pointer;
          .workItemText {
            display: inline-block;
            height: 100%;
            width: 100%;
            padding: 0 30px;
            line-height: 30px;
            transform: skewX(20deg);
          }
        }
      }
      .download {
        position: absolute;
        top: 14px;
        right: 30px;
        border-radius: 2px;
        // border: none !important;
      }
    }
    .pageContent {
      width: 98.5%;
      height: 660px;
      margin: 0 auto;
    }
    .pageContent1 {
      width: 100%;
      height: 1220px;
      background: #ffffff;
      padding-left: 0.75%;
    }
  }
}
</style>